const dataContentServicesHome = [
  {
    id: "1",
    title: "Bank Sampah",
    content:
      "Bisa menabung sampah dan mendapatkan keuntungan yang kami tawarkan. Anda dapat memilih keuntungan yang Anda butuhkan.",
    imageUrl: "url(./images/zibik-iR4mClggzEU-unsplash.jpg)",
  },
  {
    id: "2",
    title: "Transfer",
    content:
      "Metode pembayaran menggunakan transfer dapat memudahkan penerimaan pembayaran.",
    imageUrl: "url(./images/clay-banks-c2a0TydMlAs-unsplash.jpg)",
  },
  {
    id: "3",
    title: "Pick Up Sampah",
    content:
      "Anda hanya perlu menunjukkan di mana lokasi penjemputan sampah. Tim kami akan mengumpulkan sampah di tempat Anda.",
    imageUrl: "url(./images/stephane-legrand-zw0b1_3F4yg-unsplash.jpg)",
  },
];

export default dataContentServicesHome;
